<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="3"> </caass-schoolselector>
						</div>
					</div>

					<!--PcentBaseAttendance-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Base Attendance %</label>
						<div class="col-sm-4 col-lg-3">
							<input class="form-control" type="number" name="PcentBaseAttendance" [(ngModel)]="report.PcentBaseAttendance" />
						</div>
					</div>

					<!--BaseStudentsCutting-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Base Students Cutting</label>
						<div class="col-sm-4 col-lg-3">
							<input class="form-control" type="number" name="BaseStudentsCutting" [(ngModel)]="report.BaseStudentsCutting" />
						</div>
					</div>

					<!--BaseClassCutsPerDay-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Base Cuts Per Day</label>
						<div class="col-sm-4 col-lg-3">
							<input class="form-control" type="number" name="BaseClassCutsPerDay" [(ngModel)]="report.BaseClassCutsPerDay" />
						</div>
					</div>

					<!--StartMonthID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Start Month</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="MonthID" [(ngModel)]="report.MonthID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of MonthList" [ngValue]="o.MonthID">
									{{ o.MonthDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--StartYearID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Start Year</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="YearID" [(ngModel)]="report.YearID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YearList" [ngValue]="o.YearID">
									{{ o.YearDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
